/**
 * Created by PanJiaChen on 16/11/18.
 */

import { getRewardType } from '@/api/config/slot'
import storage from '@/utils/storage'

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  if (time_str.indexOf('01-01-01') > -1) {
    return '-'
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    return value.toString().padStart(2, '0')
  })

  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i)
    if (code > 0x7f && code <= 0x7ff) s++
    else if (code > 0x7ff && code <= 0xffff) s += 2
    if (code >= 0xDC00 && code <= 0xDFFF) i--
  }
  return s
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
    decodeURIComponent(search)
      .replace(/"/g, '\\"')
      .replace(/&/g, '","')
      .replace(/=/g, '":"')
      .replace(/\+/g, ' ') +
    '"}'
  )
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  const timestamp = +new Date() + ''
  const randomNum = parseInt((1 + Math.random()) * 65536) + ''
  return (+(randomNum + timestamp)).toString(32)
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}

/**
 * @param {Array} filterVal
 * @param {Object} jsonData
 * @returns {string}
 */
export function formatJson(filterVal, jsonData) {
  return jsonData.map(v => filterVal.map(j => {
    if (j === 'timestamp') {
      return parseTime(v[j])
    } else {
      return v[j]
    }
  }))
}

export function getRewardListForType(prize, rewardType, typ = -1) {
  const str = []
  for (const i in prize) {
    const r = prize[i]
    for (const k in rewardType) {
      const rt = rewardType[k]
      if (r.type === rt.value) {
        if (typ > -1 && typ !== r.is_ts) {
          continue
        }
        let text = rt.label + '*' + r.num
        if (r.type === 14) {
          if (r.rtype === 2) {
            text += '*等级取值'
          } else {
            text += '*只取数量'
          }
        }

        str.push(text)
      }
    }
  }
  return str.join(',')
}

export function getRewardListForPropsId(prize, rewardType, typ = -1) {
  const str = []
  if (!rewardType) {
    getRewardType().then(res => {
      for (const i in res.data) {
        rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
      }
    })
  }
  // console.log('r', typeof prize)

  for (const i in prize) {
    const r = prize[i]
    for (const k in rewardType) {
      const rt = rewardType[k]
      if (r.propsId === rt.value) {
        if (typ > 0 && typ !== rt.ts) {
          continue
        }
        let text = rt.label + '*' + r.num
        if (r.propsId === 14) {
          if (r.rtype === 2) {
            text += '*等级取值'
          } else {
            text += '*只取数量'
          }
        }
        str.push(text)
        break
      }
    }
  }
  return str.join(',')
}

export function dateStrTodate(originalDate) {
  const date = new Date(originalDate)
  let month = date.getMonth() + 1 // getMonth()返回的月份从0开始，所以需要+1
  let day = date.getDate()
  month = month < 10 ? '0' + month : month
  day = day < 10 ? '0' + day : day
  const formattedDate = month + '-' + day
  return formattedDate
}

export function scientificFormat(value) {
  if (value === 0) {
    return 0
  } else {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
}

export function _trim(arr) {
  for (const i in arr) {
    const _object = arr[i]
    if (typeof _object === 'object') {
      for (const k in _object) {
        if (typeof _object[k] === 'string') {
          arr[i][k] = _object[k].replace(/\s/g, '')
        }
      }
    }

    if (typeof _object === 'string') {
      arr[i] = _object.replace(/\s/g, '')
    }
  }
  return arr
}

/**
 * 获取前面的日期
 * string
 */
export function getLastDates(day) {
  const now = new Date()
  // 获取7天前的日期
  const sevenDaysAgo = new Date()
  sevenDaysAgo.setDate(now.getDate() - day)
  const formatDate = (date) => {
    const year = date.getFullYear()
    const month = ('0' + (date.getMonth() + 1)).slice(-2) // 月份从0开始
    const day = ('0' + date.getDate()).slice(-2)
    return `${year}-${month}-${day}`
  }

  return formatDate(sevenDaysAgo)
}

export function getCacheConfig(func, name = '', params = {}) {
  const funcName = name
  const data = localStorage.getItem(funcName)
  if (data) {
    return new Promise((resolve, reject) => {
      resolve(JSON.parse(data))
    })
  } else {
    return func(params).then(item => {
      if (item) {
        localStorage.setItem(funcName, JSON.stringify(item))
      }
      return item
    })
  }
}

export function getUserConsumeLabel() {
  return [
    { 'label': '全部', value: 0 },
    { 'label': '付费', value: 1 },
    { 'label': '非付费', value: 2 }
  ]
}

export function convertTime(seconds) {
  if (seconds >= 3600) {
    // 计算小时数和剩余分钟数
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)

    // 根据分钟和小时是否为0来决定显示格式
    if (minutes === 0) {
      return `${hours}h` // 如果分钟为 0，只显示小时
    }
    return `${hours}h ${minutes}m` // 显示小时和分钟
  } else if (seconds >= 60) {
    const minutes = Math.floor(seconds / 60)
    return `${minutes}m` // 显示分钟
  } else {
    // 如果小于60秒，直接显示秒数
    return `${seconds}s`
  }
}

// 页面加载是检查是否有锚点
export function scrollToAnchor() {
  setTimeout(() => {
    if (window.location.hash) {
      const targetElement = document.querySelector(window.location.hash)
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }, 500)
}

export function handleImportPrize(sheetData, typeConversion = {}) {
  sheetData.forEach(item => {
    Object.keys(item).forEach(key => {
      let value = item[key]

      if (typeConversion[key] !== undefined) {
        switch (typeConversion[key]) {
          case 'array':
            value = value.split(',')
            break
        }
        item[key] = value
      }

      if (Array.isArray(value)) {
        value = value.filter(entry => {
          const propsId = entry.propsId
          return propsId !== '' && propsId !== 0 && propsId !== null && propsId !== undefined
        })

        value.forEach(entry => {
          if (entry.propsId === 14 && entry.rtype === '') {
            entry.rtype = 2
          }
        })

        item[key] = value
      }
    })
  })

  return sheetData
}

export function setCacheQuery(name, query) {
  if (typeof query !== 'object') {
    return query
  }

  storage.set(name, query)
}

export function getCacheQuery(name, query, event) {
  if (typeof event !== 'undefined') {
    return query
  }
  const getQuery = storage.get(name)
  if (getQuery) {
    for (const i in query) {
      query[i] = getQuery[i]
    }
  }
  return query
}
